module.exports = __webpack_public_path__ + "962806d9a75fcbabf62108fc5ed88d2e.fbx";